export const isIE11 =
  navigator.userAgent && navigator.userAgent.includes('Trident');
